import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { WorkflowStageTaskProvider } from '~/features/workflowing/tasks/WorkflowStageTaskContext';
import { getWorkflowOptions, getWorkflowStageTaskOptions } from '@generated';
import { useGoBack } from '~/shared/routing/useGoBack';
import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';
import { CancelButton } from '~/shared/forms/buttons/CancelButton';
import { FormSubmitButton } from '~/shared/forms/buttons/FormSubmitButton';
import { Check } from 'lucide-react';
import { getSearchQueryKey } from '~/util/http/useSearch';

export function ChartWorkflowStageTaskRoute() {
	const { taskId } = useParams<'taskId'>();
	const { data: workflowStageTask } = useSuspenseQuery(getWorkflowStageTaskOptions(taskId!));
	const goBack = useGoBack();

	return (
		<WorkflowStageTaskProvider
			workflowStageTask={workflowStageTask}
			sectionProps={{
				footer: (
					<FooterButtonContainer className="justify-between p-4">
						<CancelButton goBackOnCancel />
						<FormSubmitButton submitLabel="Complete" submittingLabel="Completing" Icon={Check} />
					</FooterButtonContainer>
				)
			}}
			invalidateQueryKeys={[
				getWorkflowStageTaskOptions(workflowStageTask.id).queryKey,
				getWorkflowOptions(workflowStageTask.workflowId).queryKey,
				getSearchQueryKey('workflow-stage-task')
			]}
			onSuccess={goBack}
		/>
	);
}
